var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/exit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.32372 5.32372C5.75536 4.89209 6.45517 4.89209 6.8868 5.32372L12 10.4369L17.1132 5.32372C17.5448 4.89209 18.2446 4.89209 18.6763 5.32372C19.1079 5.75536 19.1079 6.45517 18.6763 6.8868L13.5631 12L18.6763 17.1132C19.1079 17.5448 19.1079 18.2446 18.6763 18.6763C18.2446 19.1079 17.5448 19.1079 17.1132 18.6763L12 13.5631L6.8868 18.6763C6.45517 19.1079 5.75536 19.1079 5.32372 18.6763C4.89209 18.2446 4.89209 17.5448 5.32372 17.1132L10.4369 12L5.32372 6.8868C4.89209 6.45517 4.89209 5.75536 5.32372 5.32372Z",
    fill: "#B5B1B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.de5df1c3ce6db79d54b476fe5ea4f81e.svg";
export { ForwardRef as ReactComponent };